import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mmb-web-app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss']
})
export class InputSearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
